import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { picwordService } from '@/services/picword';
import { computed } from 'vue';

export function usePicwordPetList() {
    const crudAction = useCrudActions();

    const { query, updateQueryToRoute } = useRouteQuery({
        name: 'PicwordPetList',
        definition: {
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { list, total, fetchList } = useBaseListView({
        request: picwordService.pet.list,
        paramsBuilder: () => ({ ...query }),
        hooks: {
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute
        }
    });

    const { list: petIds, fetchList: fetchAllPets } = useBaseListView({ request: picwordService.pet.all });
    const picwordPetOptions = computed(() => petIds.value.map(petId => ({ label: `Pet_${petId}`, value: petId })));

    const actions = {
        remove: crudAction.confirmAndRemove({
            request: picwordService.pet.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, query, fetchList, picwordPetOptions, fetchAllPets, actions };
}
